module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[70]313.76c3197.woff2";